var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.676 77.338C154.676 120.05 120.051 154.676 77.337 154.676C34.625 154.676 0 120.05 0 77.338C0 34.625 34.625 0 77.337 0C120.051 0 154.676 34.625 154.676 77.338Z",
    fill: "#D8D423"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.971 75.009C147.8 111.676 119.656 123.52 73.994 123.52C21.982 123.52 12.386 108.804 25.588 74.6C36.916 45.248 57 41.643 75.023 41.643C93.047 41.642 113.721 48.659 127.971 75.009Z",
    fill: "#E0DCD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.263 101.119C119.564 108.914 107.108 111.032 92.4321 112.576C84.6371 107.88 83.0841 80.147 85.0051 71.252C87.0661 61.726 96.5081 54.431 109.08 64.349C116.227 69.984 128.961 93.325 124.263 101.119Z",
    fill: "#BAB7B0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.262 102.406C34.958 110.201 53.981 112.448 63.377 113.477C71.174 108.781 73.979 81.936 71.488 69.836C69.656 60.921 56.17 51.297 44.068 64.557C31.967 77.818 25.563 94.612 30.262 102.406Z",
    fill: "#BAB7B0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.35 79.0229C93.35 83.6169 97.075 87.338 101.666 87.338C106.257 87.338 109.98 83.6159 109.98 79.0229C109.98 74.4309 106.257 70.7079 101.666 70.7079C97.075 70.7079 93.35 74.4309 93.35 79.0229Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.458 79.094C97.458 81.419 99.341 83.302 101.667 83.302C103.991 83.302 105.875 81.418 105.875 79.094C105.875 76.769 103.991 74.886 101.667 74.886C99.34 74.886 97.458 76.768 97.458 79.094Z",
    fill: "#3B3E43"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.719 75.787C100.719 77.007 101.707 77.997 102.929 77.997C104.15 77.997 105.14 77.007 105.14 75.787C105.14 74.566 104.15 73.577 102.929 73.577C101.707 73.578 100.719 74.566 100.719 75.787Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2169 76.918C61.2169 81.511 57.4939 85.234 52.9019 85.234C48.3099 85.234 44.5859 81.511 44.5859 76.918C44.5859 72.327 48.3099 68.602 52.9019 68.602C57.4939 68.602 61.2169 72.328 61.2169 76.918Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1099 76.99C57.1099 79.314 55.2259 81.198 52.9009 81.198C50.5779 81.198 48.6919 79.314 48.6919 76.99C48.6919 74.664 50.5779 72.78 52.9009 72.78C55.2259 72.78 57.1099 74.664 57.1099 76.99Z",
    fill: "#3B3E43"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.85 73.683C53.85 74.904 52.86 75.892 51.638 75.892C50.418 75.892 49.429 74.904 49.429 73.683C49.429 72.461 50.418 71.4709 51.638 71.4709C52.86 71.4719 53.85 72.461 53.85 73.683Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.333 103.695C104.333 112.226 88.329 119.142 74.501 119.142C60.673 119.142 49.464 112.226 49.464 103.695C49.464 95.162 60.673 88.245 74.501 88.245C88.329 88.245 104.333 95.162 104.333 103.695Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.286 102.666C87.286 106.652 82.634 111.612 76.897 111.612C71.16 111.612 66.51 106.652 66.51 102.666C66.51 98.682 71.16 95.452 76.897 95.452C82.633 95.452 87.286 98.682 87.286 102.666Z",
    fill: "#3B3E43"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83.664 100.506C83.422 101.463 82.004 101.927 80.497 101.544C78.992 101.161 77.969 100.077 78.21 99.121C78.454 98.164 79.872 97.701 81.378 98.083C82.883 98.466 83.907 99.55 83.664 100.506Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.872 31.686C28.319 35.332 36.147 59.492 36.147 59.492L61.732 44.402C61.732 44.402 43.426 28.039 35.872 31.686Z",
    fill: "#E0DCD3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.954 35.224C33.88 37.674 39.142 53.9069 39.142 53.9069L56.332 43.7689C56.332 43.7689 44.03 32.774 38.954 35.224Z",
    fill: "#BAB7B0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M118.696 31.686C126.248 35.332 118.42 59.492 118.42 59.492L92.837 44.402C92.837 44.402 111.143 28.039 118.696 31.686Z",
    fill: "#E0DCD3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M115.612 35.224C120.688 37.674 115.428 53.9069 115.428 53.9069L98.2371 43.7689C98.2371 43.7689 110.539 32.774 115.612 35.224Z",
    fill: "#BAB7B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.2b346086d172c6fd76e06ae749931db5.svg";
export { ForwardRef as ReactComponent };